import { memo, useEffect, useState } from "react";
import { getDHM } from "@/utils/dhmCalculation";

const CountdownTimer = ({until, isRecommendedProperties, isMapCard}) => {
  const currentDate = new Date();
  const futureDate = new Date();
  const safeUntil = until && !isNaN(until) ? until : 0;
  futureDate.setDate(currentDate.getDate() + parseInt(safeUntil / (60 * 60 * 24), 10))
  futureDate.setHours(currentDate.getHours() + parseInt(safeUntil / (60 * 60), 10) % 24)
  futureDate.setMinutes(currentDate.getMinutes() + parseInt(safeUntil / 60, 10) % 60)
  futureDate.setSeconds(currentDate.getSeconds() + safeUntil % 60)
  const [getCurrentTime, setCurrentTime] = useState(getDHM(futureDate));

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(getDHM(futureDate))
    }, 60000);
    return () => clearInterval(intervalId);
  }, [until]);

  const digitFormatter = (num) =>{
    return num?.toString().padStart(2, '0');
  }

  return (
    <div className={`mt14 align-items-center d-flex timer-text ${isMapCard ? 'mb0 mt2 ml5' : isRecommendedProperties ? 'mt0 mb0' : 'mb20'}`} tabIndex="0" >
      <svg xmlns="http://www.w3.org/2000/svg" width={isMapCard ? "20" : "26"} height={isMapCard ? "20" : "26"} viewBox="0 0 30 30" fill="none">
        <circle cx="13.5" cy="13.5" r="12" fill="white" stroke="#118BF4" strokeWidth="1.5"></circle>
        <path d="M12.5 6.5V15H19.5" stroke="#118BF4" strokeWidth="1.5" strokeLinecap="round"></path>
      </svg>
      {getCurrentTime?.days > 0 && (
        <>
          <div className={`cols ${isMapCard ? "ml5 mr5": "ml10 mr10 "}`}>
            <p className="listingTime">{digitFormatter(getCurrentTime?.days) || '00'}</p>
            <p className={`listingTimeLabel ${isMapCard ? 'mapLabel' : ''}`}>{isMapCard ? 'Days' : 'Days'}</p>
          </div>
          <p className="bold text-center mb0">:</p>
        </>
      )}
      <div className={`cols ${isMapCard ? "ml5 mr5": "ml10 mr10 "}`}>
        <p className="listingTime">{digitFormatter(getCurrentTime?.hours) || '00'}</p>
        <p className={`listingTimeLabel ${isMapCard ? 'mapLabel' : ''}`}>{isMapCard ? 'Hours' : 'Hours'}</p>
      </div>
      <p className="bold text-center mb0">:</p>
      <div className={`cols ${isMapCard ? "ml5 mr5": "ml10 mr10 "}`}>
        <p className="listingTime">{digitFormatter(getCurrentTime?.minutes) || '00'}</p>
        <p className={`listingTimeLabel ${isMapCard ? 'mapLabel' : ''}`}>{isMapCard ? 'Mins' : 'Minutes'}</p>
      </div>
      {getCurrentTime?.days <= 0 && (
        <>
          <p className="bold text-center mb0">:</p>
          <div className={`cols ${isMapCard ? "ml5 mr5": "ml10 mr10 "}`}>
            <p className="listingTime">{digitFormatter(getCurrentTime?.seconds) || '00'}</p>
            <p className={`listingTimeLabel ${isMapCard ? 'mapLabel' : ''}`}>{isMapCard ? 'Secs' : 'Seconds'}</p>
          </div>
        </>
      )}
    </div>
  );
};

export default memo(CountdownTimer);
